import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { l } from '@manychat/manyui'

import * as buttonActions from 'common/builder/actions/buttonActions'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { getFlowConditionFields } from 'common/builder/selectors/builder/fieldsSelectors'
import { Filters } from 'common/filter'

import theme from './BuyButtonConditionFiltersController.module.css'

const BuyButtonConditionFiltersController = connect(
  (state, props) => {
    const { builderId, buttonId } = props
    const button = entitySelectors.getButtonById(state, builderId, buttonId)

    return {
      theme,
      operatorSelectorAlwaysVisible: true,
      filter: button?.filter,
      caption: l.translate('Purchase available only with'),
      fieldsSelector: getFlowConditionFields,
    }
  },
  (dispatch, props) => ({
    onChange: (filter) => {
      dispatch(
        buttonActions.updateButton(props.builderId, props.buttonId, {
          filter,
        }),
      )
    },
  }),
)(Filters)

BuyButtonConditionFiltersController.propTypes = {
  builderId: PropTypes.string.isRequired,
  buttonId: PropTypes.string.isRequired,
}

export default BuyButtonConditionFiltersController
